import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button            from '@material-ui/core/Button'
import Dialog            from '@material-ui/core/Dialog'
import DialogActions     from '@material-ui/core/DialogActions'
import DialogContent     from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Grid              from '@material-ui/core/Grid'
import List              from '@material-ui/core/List'
import ListItem          from '@material-ui/core/ListItem'
import Typography        from '@material-ui/core/Typography'

import { User as TUser }          from '../../api'
import { genFullName }            from '../../project-utils'
import { LabelledText }           from '../atoms'
import ExperienceCardContent      from './ExperienceCard'
import ProfileAvatar              from './ProfileAvatar'
import EducationalAchievementCard from './Study'

interface UserInfoPopupProps {
  user: TUser
  isOpen: boolean
  close: () => void
}

const UserInfoPopup = ({
  user,
  close,
  isOpen,
}: UserInfoPopupProps) => {
  const phrasing = {
    close:
      (
        <FormattedMessage id={'buttonActions.close'} />
      ),
    personalInfo:
      (
        <Typography paragraph variant={'subheading'}>
          <FormattedMessage
            id={'generic.personalInformation'}
            defaultMessage={'Personal Information'}
          />
        </Typography>
      ),
    education:
      (
        <Typography paragraph variant={'subheading'}>
          <FormattedMessage
            id={'dictionary.education'}
            defaultMessage={'Education'}
          />
        </Typography>
      ),
    experience:
      (
        <Typography paragraph variant={'subheading'}>
          <FormattedMessage
            id={'dictionary.experience'}
            defaultMessage={'Experience'}
          />
        </Typography>
      ),
    /* TODO: find out if this is implemented of the server */
    /*
     teachingExperience:
     (
     <Typography paragraph variant={'subheading'}>
     <FormattedMessage
     id={'generic.teachingExperience'}
     defaultMessage={'Teaching Experience'}
     />
     </Typography>
     ),
     */
  }

  const { personal } = user

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogContent>
        <Grid container spacing={40} direction={'column'}>
          <Grid item>
            <DialogContentText>
              {phrasing.personalInfo}
            </DialogContentText>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <ProfileAvatar name={personal && personal.name} img={personal && personal.photo} />
              </Grid>
              <Grid item>
                <LabelledText label={<FormattedMessage id={'labels.name'} />}>
                  {genFullName({ firstName: personal && personal.name, surname: personal && personal.surname })}
                </LabelledText>
              </Grid>
              <Grid item>
                <LabelledText label={<FormattedMessage id={'labels.email'} />}>
                  {user.account && user.account.email}
                </LabelledText>
              </Grid>
              <Grid item>
                <LabelledText label={<FormattedMessage id={'labels.mobile'} />}>
                  {personal && personal.mobile}
                </LabelledText>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <DialogContentText>
              {phrasing && phrasing.education}
            </DialogContentText>
            <List>
              {user.studies.map((educationalAchievement, i) => (
                <ListItem divider={i + 1 < user.studies.length} key={i}>
                  <EducationalAchievementCard {...educationalAchievement} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item>
            <DialogContentText>
              {phrasing.experience}
            </DialogContentText>
            <List>
              {user.experience.map((item, i) => (
                <ListItem divider={i + 1 < user.experience.length} key={i}>
                  <ExperienceCardContent {...item} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color={'secondary'}>
          {phrasing.close}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UserInfoPopup



// WEBPACK FOOTER //
// ./src/components/molecules/UserInfoPopup.tsx